
import { PropType, defineComponent } from 'vue';
import { AxiosError } from 'axios';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';
import GenericError from '@/components/common/Alerts/GenericError.vue';
import { formattedDate } from '@/utils/dates';
import { submitOneTimePayment } from '@/api/loan';
import PaymentAmountWarning from '@/components/Payments/PaymentAmountWarning.vue';
import { DebitPaymentFailureReasons } from '@/interfaces/payment-options';
import AchProvidersMixin from '@/mixins/AchProvidersMixin';

type PaymentOption = { id: string; type: 'card' | 'bank'; lastFour: string };

export default defineComponent({
  name: 'ConfirmPaymentDialog',

  components: {
    CustomButton,
    CustomDialog,
    GenericError,
    PaymentAmountWarning,
  },

  mixins: [AchProvidersMixin],

  props: {
    amount: { type: [String, Number], required: true },
    paymentOption: { type: Object as PropType<PaymentOption>, required: true },
  },

  data: () => ({
    loading: false,
    showError: false,
  }),

  computed: {
    date() {
      return formattedDate();
    },

    loanNumber() {
      return this.$store.getters['User/activeLoanNumber'];
    }
  },

  methods: {
    async submitPayment() {
      this.loading = true;
      try {
        const { data } = await submitOneTimePayment(
          Number(this.amount),
          {
            id: this.paymentOption.id,
            type: this.paymentOption.type,
          },
          this.loanNumber,
          this.achProvider
        );
        this.$emit('confirm', data.payment_id);
      } catch (ex) {
        const error = ex as AxiosError;

        if (this.paymentOption.type === 'card') {
          if (error.response?.status === 400 && error.response.data.reason) {
            this.$emit('error', error.response.data);
          } else {
            this.$emit('error', {
              reason: DebitPaymentFailureReasons.OTHER,
              error: ''
            });
          }
        }

        this.showError = true;
      } finally {
        this.loading = false;
      }
    }
  }
});
